import utils from 'utils';

import {useNavigate} from 'react-router-dom';

export const HeaderNavMenu = () => {
    const navigate = useNavigate();

    const pathname = window.location.pathname;

    const data = {
        links: [
            {title: 'Dle zakázek', location: '/orders/byOrders', active: pathname.includes('/orders/byOrders')},
            {title: 'Dle produktů', location: '/orders/byProducts', active: pathname.includes('/orders/byProducts')},
            {title: 'Report', location: '/report', active: pathname.includes('/report')},
        ],
    };

    return <>
        {
            data.links.map((link) => {
                return <a
                    onClick={() => navigate(link.location)}
                    key={link.title}
                    className={link.active ? classMap.linkActive : ''}
                >
                    <span>{link.title}</span>
                </a>;
            })
        }
    </>;
};

const cmpClass = 'header-nav-menu';
const classMap = utils.generateClassMap(cmpClass, {
    linkActive: 'link-active',
});
